module.exports = __webpack_public_path__ + "media/images/how_it_works/2-eb71b4bb5d10ebb062c35fed182cb4f0.svg";